import { render, staticRenderFns } from "./Lazer.vue?vue&type=template&id=4fd91fc0&scoped=true&"
import script from "./Lazer.vue?vue&type=script&lang=js&"
export * from "./Lazer.vue?vue&type=script&lang=js&"
import style0 from "./Lazer.vue?vue&type=style&index=0&id=4fd91fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd91fc0",
  null
  
)

export default component.exports